import { ITrigger } from '../types/operations.types'

export const MOCK_TRIGGERS: ITrigger[] = [
  {
    id: 'trg-001',
    name: 'Daily Inspection 06:00',
    scope: 'All Sites',
    type: 'Time',
    condition: 'Every day at 06:00',
    lastFired: '2026-03-26T06:00:00Z',
    nextExpected: '2026-03-27T06:00:00Z',
    enabled: true,
  },
  {
    id: 'trg-002',
    name: 'Low Fuel Alert',
    scope: 'Fleet',
    type: 'Threshold',
    condition: 'Fuel < 20%',
    lastFired: '2026-03-26T10:22:00Z',
    nextExpected: 'On condition',
    enabled: true,
  },
  {
    id: 'trg-003',
    name: 'Breakdown to Maintenance',
    scope: 'All Machines',
    type: 'Event',
    condition: 'Status=BREAKDOWN',
    lastFired: '2026-03-25T14:30:00Z',
    nextExpected: 'On event',
    enabled: true,
  },
  {
    id: 'trg-004',
    name: 'Task Complete to Next Step',
    scope: 'Workflows',
    type: 'Completion',
    condition: 'Task=DONE',
    lastFired: '2026-03-26T11:05:00Z',
    nextExpected: 'On event',
    enabled: true,
  },
  {
    id: 'trg-005',
    name: 'Shift Start Generate Tasks',
    scope: 'Operations',
    type: 'Time',
    condition: 'Shift start detected',
    lastFired: '2026-03-20T06:00:00Z',
    enabled: false,
  },
]
